{
  "version": 1,
  "asset_id": "42890b90-d112-47c9-be41-28c74aac878c",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/42890b90-d112-47c9-be41-28c74aac878c/aleph-animal-800.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/42890b90-d112-47c9-be41-28c74aac878c/aleph-animal-800.webp",
  "original_filename": "aleph-animal-800.webp",
  "size": 66894,
  "content_type": "image/webp",
  "created_at": "2026-10-20T23:04:49Z"
}
